
export const authConfig = {
  getRedirectUrl: () => {
    const base = window.location.origin;
    return `${base}/auth/reset-password?type=recovery`;
  }
};
